import './ListingMap.scss';
import Component from './ListingMap.js';
export default Component;
